import RowPanel from "@/components/RowPanel.vue";
export const rowPanelInit = {
    component: RowPanel,
    name: "RowPanel",
    canHaveChildren: true,
    inputs: [
        {
            name: "textAlign",
            type: "string",
            enum: ["left", "center", "right", "justify"],
            defaultValue: "left"
        },
        {
            name: "pictureOrientation",
            type: "string",
            enum: ["left", "right"],
            defaultValue: "left"
        },
        {
            name: "rows",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "heading",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "subtext",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "image",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "gif", "svg"]
                },
                {
                    name: 'imageAlt',
                    type: 'string',
                    defaultValue: ""
                }
            ]
        }
    ]
};
